import { Icon } from "./Icon.tsx";

/** "Undo" toolbar button icon — a counter-clockwise curved arrow. */
export function UndoIcon() {
  return (
    <Icon>
      <path d="M9 14 4 9l5-5" />
      <path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11" />
    </Icon>
  );
}
